import { Facebook, Instagram, WhatsApp } from "@mui/icons-material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import {
  Box,
  Button,
  Divider,
  Stack,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import axios from "axios";
import Cookies from "js-cookie";
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../asset/images/logo.png";
import ValidateEmail from "../asset/js/ValidateEmail";
import { Copyright } from "./Copyright";

function Footer() {
  const [email, setEmail] = useState("");
  const [title, setTitle] = useState("");
  const [mes, setMes] = useState("");
  const [validEmail, setValidEmail] = useState(true);

  const StyledInstagramIcon = styled(Instagram)({
    color: "#E4405F",
    "&:hover": { color: "#E4405F" },
  });
  const StyledFacebookIcon = styled(Facebook)({
    color: "#1877F2",
    "&:hover": { color: "#1877F2" },
  });
  const StyledWhatsappIcon = styled(WhatsApp)({
    color: "#25D366",
    "&:hover": { color: "#25D366" },
  });

  const sendMail = () => {
    if (!ValidateEmail(email)) {
      setValidEmail(false);
      return;
    }
    axios
      .post(
        `${process.env.React_APP_BACKEND_URL}/api/customermail`,
        { title, mes, email },
        { headers: { Authorization: `Bearer ${Cookies.get("token")}` } }
      )
      .then((res) => {
        setTitle("");
        setMes("");
        setEmail("");
        setValidEmail(true);
        console.log(res);
      })
      .catch((err) => console.log(err));
  };

  const footerLinkSx = {
    display: "inline-flex",
    alignItems: "center",
    width: "fit-content",
    color: "rgba(255,255,255,.78)",
    fontFamily: `${process.env.REACT_APP_FONT}`,
    fontSize: "0.94rem",
    lineHeight: 1.7,
    transition: "color .18s ease, transform .18s ease",
    "&:hover": {
      color: "#ffffff",
      transform: "translateX(-3px)",
    },
  };

  const fieldSx = {
    mt: 0.75,
    mb: 1.35,
    "& .MuiOutlinedInput-root": {
      minHeight: 44,
      borderRadius: "12px",
      backgroundColor: "rgba(255,255,255,.96)",
      fontFamily: `${process.env.REACT_APP_FONT}`,
      "& fieldset": { borderColor: "rgba(255,255,255,.2)" },
      "&:hover fieldset": { borderColor: "#FAAF3C" },
      "&.Mui-focused fieldset": {
        borderColor: "#FAAF3C",
        borderWidth: "2px",
      },
    },
    "& .MuiInputBase-input": {
      py: 1.15,
      fontFamily: `${process.env.REACT_APP_FONT}`,
    },
  };

  const sectionTitleSx = {
    color: "#ffffff",
    fontFamily: `${process.env.REACT_APP_FONT}`,
    fontWeight: 800,
    fontSize: "1rem",
    mb: 1.5,
    position: "relative",
    pb: 1,
    "&::after": {
      content: '""',
      position: "absolute",
      right: 0,
      bottom: 0,
      width: 34,
      height: 3,
      borderRadius: 8,
      background: "linear-gradient(90deg, #FAAF3C, #FFD28A)",
    },
  };

  const socialButtonSx = {
    width: 42,
    height: 42,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "12px",
    backgroundColor: "rgba(255,255,255,.96)",
    boxShadow: "0 8px 22px rgba(3,18,40,.2)",
    transition: "transform .18s ease, box-shadow .18s ease",
    "&:hover": {
      transform: "translateY(-3px)",
      boxShadow: "0 12px 28px rgba(3,18,40,.28)",
    },
  };

  return (
    <Box
      component="footer"
      dir="rtl"
      sx={{
        fontFamily: `${process.env.REACT_APP_FONT}`,
        mt: { xs: 4, md: 7 },
        color: "white",
        background:
          "linear-gradient(145deg, #082B59 0%, #0B4D91 52%, #1177C8 100%)",
        borderTop: "4px solid #FAAF3C",
        overflow: "hidden",
        width: "100%",
        maxWidth: "100%",
        boxSizing: "border-box",
        mb: 0,
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          maxWidth: 1280,
          mx: "auto",
          px: { xs: 2, sm: 3, md: 5 },
          pt: { xs: 4, md: 5.5 },
          pb: 3,
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, minmax(0, 1fr))",
              md: "1.05fr 1.35fr 1.25fr",
            },
            gap: { xs: 3.5, md: 5 },
            alignItems: "start",
          }}
        >
          <Box sx={{ minWidth: 0, alignSelf: "start" }}>
            <NavLink to="/" style={{ textDecoration: "none" }}>
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1.25,
                  mb: 1.7,
                }}
              >
                <Box
                  component="img"
                  src={logo}
                  alt="Bidit logo"
                  sx={{
                    width: 58,
                    height: 58,
                    objectFit: "contain",
                    borderRadius: "50%",
                    backgroundColor: "white",
                    p: 0.35,
                    boxShadow: "0 10px 28px rgba(0,0,0,.22)",
                  }}
                />
                <Box>
                  <Typography
                    sx={{
                      color: "white",
                      fontFamily: `${process.env.REACT_APP_FONT}`,
                      fontWeight: 900,
                      fontSize: "1.35rem",
                      lineHeight: 1.1,
                    }}
                  >
                    בידאיט
                  </Typography>
                  <Typography
                    sx={{
                      color: "#FFD28A",
                      fontFamily: `${process.env.REACT_APP_FONT}`,
                      fontWeight: 700,
                      fontSize: "0.88rem",
                      mt: 0.35,
                    }}
                  >
                    פשוט למצוא בעל מקצוע
                  </Typography>
                </Box>
              </Box>
            </NavLink>

            <Typography
              sx={{
                maxWidth: 285,
                color: "rgba(255,255,255,.72)",
                lineHeight: 1.75,
                fontSize: "0.92rem",
                mb: 2,
              }}
            >
              מפרסמים את העבודה ומקבלים הצעות מבעלי מקצוע באזורכם, בצורה פשוטה ונוחה.
            </Typography>

            <Typography sx={sectionTitleSx}>דיגיטל ויצירת קשר</Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: { xs: "center", sm: "flex-start" },
                gap: "16px",
                flexWrap: "wrap",
                width: "100%",
              }}
            >
              <Box
                component="a"
                href="https://wa.me/972553181000"
                target="_blank"
                rel="noreferrer"
                aria-label="WhatsApp"
                sx={socialButtonSx}
              >
                <StyledWhatsappIcon />
              </Box>
              <Box
                component="a"
                href="https://facebook.com/100092381437181"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
                sx={socialButtonSx}
              >
                <StyledFacebookIcon />
              </Box>
              <Box
                component="a"
                href="https://www.instagram.com/biditsimple"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                sx={socialButtonSx}
              >
                <StyledInstagramIcon />
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              mt: { xs: 2, md: 0 },
              pt: { xs: 2, md: 0 },
              borderTop: {
                xs: "1px solid rgba(255,255,255,.12)",
                md: "none",
              },
              display: { xs: "flex", md: "grid" },
              gridTemplateColumns: { md: "repeat(2, minmax(0, 1fr))" },
              justifyContent: "center",
              alignItems: "center",
              alignContent: "center",
              flexWrap: "wrap",
              columnGap: { xs: "18px", md: "28px" },
              rowGap: { xs: "10px", md: "17px" },
              width: "100%",
              minHeight: { md: "100%" },
              px: { md: 1.5 },
            }}
          >
            {[
              { label: "מי אנחנו", to: "/aboutus" },
              { label: "מאמרים", to: "/blog" },
              { label: "שאלות נפוצות", to: "/faq" },
              { label: "תמיכה", to: "/support" },
              { label: "פרטיות", to: "/privacypolicy" },
              { label: "תנאי שימוש", to: "/termsofuse" },
              { label: "עוגיות", to: "/cookie-policy" },
            ].map((item, index, arr) => (
              <React.Fragment key={item.to}>
                <NavLink to={item.to} style={{ textDecoration: "none" }}>
                  <Typography
                    sx={{
                      ...footerLinkSx,
                      fontWeight: { xs: 500, md: 650 },
                      fontSize: { md: "0.98rem" },
                      textAlign: { md: "right" },
                      transition: "color .2s ease, text-decoration-color .2s ease",
                      "&:hover": {
                        color: "#FAAF3C",
                        transform: "none",
                        textDecoration: "underline",
                        textUnderlineOffset: "4px",
                      },
                    }}
                  >
                    {item.label}
                  </Typography>
                </NavLink>

                {index < arr.length - 1 && (
                  <Typography
                    component="span"
                    aria-hidden="true"
                    sx={{
                      display: { xs: "inline", md: "none" },
                      color: "rgba(255,255,255,.28)",
                      lineHeight: 1,
                      userSelect: "none",
                    }}
                  >
                    |
                  </Typography>
                )}
              </React.Fragment>
            ))}
          </Box>

          <Box
            sx={{
              p: { xs: 2, md: 2.5 },
              width: "100%",
              minWidth: 0,
              borderRadius: "20px",
              backgroundColor: "rgba(255,255,255,.09)",
              border: "1px solid rgba(255,255,255,.14)",
              boxShadow: "0 18px 44px rgba(2,20,45,.18)",
              backdropFilter: "blur(8px)",
            }}
          >
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1.25 }}>
              <Box
                sx={{
                  width: 38,
                  height: 38,
                  borderRadius: "11px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(250,175,60,.18)",
                  color: "#FFD28A",
                }}
              >
                <EmailOutlinedIcon />
              </Box>
              <Box>
                <Typography
                  sx={{
                    color: "white",
                    fontWeight: 850,
                    fontFamily: `${process.env.REACT_APP_FONT}`,
                  }}
                >
                  שאלה? שלחו לנו הודעה
                </Typography>
                <Typography
                  sx={{
                    color: "rgba(255,255,255,.65)",
                    fontSize: "0.8rem",
                    mt: 0.2,
                  }}
                >
                  נחזור אליכם בהקדם
                </Typography>
              </Box>
            </Stack>

            <Typography sx={{ fontSize: "0.82rem", fontWeight: 700 }}>נושא הפנייה</Typography>
            <TextField
              size="small"
              sx={fieldSx}
              required
              fullWidth
              id="title"
              value={title}
              onChange={(e) => setTitle(e.currentTarget.value)}
              name="title"
            />

            <Typography sx={{ fontSize: "0.82rem", fontWeight: 700 }}>תוכן הפנייה</Typography>
            <TextField
              size="small"
              multiline
              minRows={2}
              sx={fieldSx}
              required
              fullWidth
              id="message"
              value={mes}
              onChange={(e) => setMes(e.currentTarget.value)}
              name="message"
            />

            <Typography sx={{ fontSize: "0.82rem", fontWeight: 700 }}>כתובת הדוא״ל שלכם</Typography>
            <TextField
              dir="rtl"
              type="email"
              size="small"
              sx={fieldSx}
              required
              fullWidth
              id="email"
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
              name="email"
            />

            {!validEmail && (
              <Typography
                role="alert"
                sx={{ color: "#FFD1D1", fontSize: "0.82rem", mb: 1.25 }}
              >
                יש להזין אימייל תקין
              </Typography>
            )}

            <Button
              fullWidth
              variant="contained"
              endIcon={<SendRoundedIcon />}
              sx={{
                mt: 0.3,
                minHeight: 43,
                borderRadius: "12px",
                background: "linear-gradient(135deg, #FAAF3C, #F59A19)",
                color: "#12233A",
                fontFamily: `${process.env.REACT_APP_FONT}`,
                fontWeight: 900,
                textTransform: "none",
                gap: 1.25,
                "& .MuiButton-endIcon": {
                  margin: 0,
                },
                "& .MuiButton-endIcon > *:nth-of-type(1)": {
                  fontSize: 20,
                },
                boxShadow: "0 8px 20px rgba(245,154,25,.28)",
                "&:hover": {
                  background: "linear-gradient(135deg, #FFBC55, #F59A19)",
                  boxShadow: "0 10px 24px rgba(245,154,25,.38)",
                },
              }}
              onClick={sendMail}
            >
              שליחה
            </Button>
          </Box>
        </Box>

        <Divider sx={{ my: { xs: 3.5, md: 4 }, borderColor: "rgba(255,255,255,.14)" }} />
        <Copyright
          sx={{
            m: 0,
            color: "rgba(255,255,255,.65)",
            "& a": { color: "#FFD28A", textDecoration: "none" },
          }}
        />
      </Box>
    </Box>
  );
}

export default Footer;
